/*
|-------------------------------------------------------------------------------
| Mixins for general methods applied accross multiple components/pages.
|-------------------------------------------------------------------------------
*/
import generalUtilMixins from '../../utilities/generalUtilMixins';

export default {
    data () {
      let margins = [30, 50, 30, 30];

      return {
        pdfMake: require('pdfmake/build/pdfmake.js'),
        pdfFonts: require('pdfmake/build/vfs_fonts.js'),
        docDefinition: {
          pageMargins: [ 0, 0, 0, 65 ],
          styles: {
            headerTop: {
              fontSize: 16,
              bold: true,
              margin: [25, 25, 25, 5],
              alignment: 'right'
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: margins
            },
            tableExample: {
              margin: margins
            },
            tableHeader: {
              bold: true,
              fontSize: 12,
              color: 'black'
            },
            tableSubHeader: {
              fillColor: 'lightgrey',
            },
            image: {
              alignment: 'left'
            },
            headerLogo: {
              margin: [25, 25, 25, 5]
            },
            expired: {
              fillColor: '#E4A4A6',
              bold: true,
            },
            warning: {
              fillColor: 'yellow',
            },
          },
          pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
            if (currentNode.id === 'topHeader' || currentNode.id === 'image') {
              return previousNodesOnPage.some(function(el) {
                return el.id === "topHeader" || el.id === "image";
              }); 
            }
  
            return false;
          }
        }
      }
    },
    mixins: [generalUtilMixins],
    mounted () {
      this.pdfMake.tableLayouts = {
        normalTable: {
          hLineWidth: function (i, node) {
            return 0.75;
          },
          vLineWidth: function (i, node) {
            return 0.75;
          },
        }
      };

      this.pdfMake.vfs = this.pdfFonts.pdfMake.vfs;
    },
    methods: {
      buildPageHeader (title) {
        return {columns: [
            {
                image: "data:image/png;base64,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",
                width: 120,
                style: 'headerLogo'
            },  
            {
                text: title,
                style: 'headerTop'
            },
          ],
          id: 'topHeader'
        };
      },
      buildPageFooter (currentPage, pageCount, identifier = "") {
        let identifierString = "";
        if (identifier != "") {
            identifierString = identifier + " - "
        }
        return {
            layout: "noBorders",
            table: {
                widths: ["*"],
                body: [
                    [
                        { text: identifierString + "Page " + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 25, 25, 0] }
                    ],
                ]
            },
        };
      },
      filterArray (data, ids) {
        let idArray = ids;
        let filteredArray = data.filter(function(item) {
            return idArray.includes(item['_id']['$oid']); 
        });
    
        return filteredArray;
      },
      filterObject (data) {
        let idArray = this.desiredIds;
        let filteredObject = Object.values(data).filter(function(item) {
          return idArray.includes(item['_id']['$oid']); 
        });
  
        return filteredObject;
      },
      pullIds (data) {
        let tempIdArray = [];
        for (let i in data) {
          tempIdArray.push(data[i]['_id']['$oid']);
        }

        return tempIdArray;
      },
      cleanPublicFileInfo(data) {
        let tempIdArray = [];

        for (let i in data) {
          for (let e in data[i]['fileInfo']) {
            tempIdArray.push(data[i]['fileInfo'][e]);
          }
        }

        return tempIdArray;
      },
      makeTable (headers, data, ids) {
        let tableStructure = [];
        let headerInfo = [];
        let bodyInfo = [];
  
        headerInfo.push(this.makeHeaders(headers));
        bodyInfo = this.makeBody(headers, data, ids);
        tableStructure = [...headerInfo, ...bodyInfo];
  
        return tableStructure;
      },
      makeHeaders (headers) {
        let cleanedHeaders = [];
  
        for (let i in headers) {
          if (!this.isOption(headers[i].name)) {
            cleanedHeaders.push({text: this.$options.filters.capitalize(headers[i].name), style: 'tableHeader'});
          }
        }
  
        return cleanedHeaders;
      },
      makeBody (headers, data, ids) {
        let cleanedBody = [];
        let tempArray = [];
        let filteredBody = this.filterArray(data, ids);
  
        for (let i in filteredBody){
            tempArray = [];
            for (let i2 in headers) {
                if (!this.isOption(headers[i2].name)) {
                    tempArray.push({text: filteredBody[i][headers[i2].name]});
                }
            }
            
            cleanedBody.push(tempArray);
        }
  
        return cleanedBody;
      },
      async makeSummaries (data, wFiles = false) {
        let cleanedBody = [];
        let tempArray = [];
        let personalTemp = [];
        let coursesArray = [];
        let courseHeaders = [];
        let activeCourses = [];
        let personalParams = ['firstName', 'lastName', 'hubUUID'];
        let courseParams = ['courseName', 'trainingProvider', 'dateIssued', 'dateExpired'];
        
        for (let index in courseParams) {
          courseHeaders.push({text: this.$options.filters.capitalize(courseParams[index]), style: 'tableHeader'});
        }
        
        let tempCourseArray = [];
        
        for (let i3 in this.courses) {
          if ('courseInfo' in data['training'][this.courses[i3]['name']]) {
            activeCourses.push(data['training'][this.courses[i3]['name']]['courseInfo']['_id']['$oid']);
            tempCourseArray.push({text: this.courses[i3]['name']});
            for (let index in courseParams) {
              if (courseParams[index] != 'courseName') {
                tempCourseArray.push({text: data['training'][this.courses[i3]['name']]['courseInfo'][courseParams[index]]});
              }
            }
            coursesArray.push(tempCourseArray);
            tempCourseArray = [];
          }
        }
  
        if (coursesArray.length > 0) {
          coursesArray.unshift(JSON.parse(JSON.stringify(courseHeaders)));
          tempArray.push(this.buildPageHeader('Training Summary'));
  
          for (let i2 in personalParams) {
            personalTemp.push([
              {text: this.$options.filters.capitalize(personalParams[i2]) + ": "}, 
              {text: data[personalParams[i2]]}
            ]);
          }
  
          tempArray.push(
            {
              style: 'tableExample',
              layout: 'noBorders',
              table: {
                body: personalTemp
              }
            }
          );
  
          tempArray.push(
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                dontBreakRows: true,
                keepWithHeaderRows: 1,
                body: coursesArray
              },
              id: "trainingTable"
            }
          );
          
          if (wFiles) {
            await this.getFileInfo(activeCourses);
            if (this.resultPdf.length > 0) {
              tempArray.push(JSON.parse(JSON.stringify(this.resultPdf)));
            }
          }      
        }
        
        cleanedBody.push(tempArray);
        tempArray = [];
        coursesArray = [];
        personalTemp = [];
        activeCourses = [];
        this.resultPdf = [];
  
        return cleanedBody;
      },
    },
    watch: {
      
    }
};
